/**
 * Theme Provider component for Material-UI v7
 * Provides theme context to the entire application
 */
import { ThemeProvider, CssBaseline } from '@mui/material';
import { memo } from 'react';
import theme from '../theme';

/**
 * Theme Provider wrapper component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @returns {React.ReactElement} Theme provider with CSS baseline
 */
const AppThemeProvider = ({ children }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
);

export default memo(AppThemeProvider);
